module.exports = __webpack_public_path__ + "static/media/user-2.93063ebd.png";